import { UserCreatePage } from "@features/security/components/UserCreatePage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { UserPlus } from "lucide-react";

/**
 * Security — User Create Route
 *
 * Form to create a new user account and assign a profile.
 * Access requires security.users.create permission.
 */
export const Route = createFileRoute("/_app/admin/users/create")({
  loader: requirePermission(PERMISSIONS.SECURITY.USERS.CREATE),
  staticData: {
    title: "Nouvel utilisateur",
    icon: UserPlus,
    permission: PERMISSIONS.SECURITY.USERS.CREATE,
    showInBreadcrumb: true,
  },
  component: UserCreatePage,
});
